import React from 'react';
import { withStyles } from "@material-ui/core";

const styles = theme => ({
    settingTitleWrapper: {
        width: '100%'
    },
    settingSubtitle: {
        fontSize: 'initial',
        color: '#bbbaba',
        fontWeight: 400,
        margin: 0,
    },
    settingTitle: {
        fontSize: '1.7rem',
        margin: '0 0 0.5rem 0'
    }
})

const SettingTitle = (props) => {
    let { classes, wrapperClass, subtitleClass, titleClass, subtitleText, titleText, reverse } = props; 
    
    return (<div className={[classes.settingTitleWrapper, wrapperClass].join(' ')}>
        {reverse 
            ? <React.Fragment>
                <h3 className={[classes.settingSubtitle, subtitleClass].join(' ')}>{subtitleText}</h3>
                <h2 className={[classes.settingTitle, titleClass].join(' ')}>{titleText}</h2>
            </React.Fragment>
            : <React.Fragment>
                <h2 className={[classes.settingTitle, titleClass].join(' ')}>{titleText}</h2>
                <h3 className={[classes.settingSubtitle, subtitleClass].join(' ')}>{subtitleText}</h3>
            </React.Fragment>
        }
    </div>)
};

export default withStyles(styles)(SettingTitle);
            